import { CodPositions } from 'src/constants';
import {
  ComponentTypes,
  DyProductSource,
  GlobalComponentsScreenInterface,
} from 'src/interfaces';

export const getCodScreenSequence = (
  globalComponentsScreen: GlobalComponentsScreenInterface | undefined,
): number | undefined => {
  return globalComponentsScreen?.globalComponents?.find(
    (component) => component.componentType === ComponentTypes.COD,
  )?.screenSequence;
};

export const getRecommendationsScreenSequence = (
  globalComponentsScreen: GlobalComponentsScreenInterface | undefined,
): number | undefined => {
  return globalComponentsScreen?.globalComponents?.find(
    (component) => component.componentVariant === DyProductSource.DYR,
  )?.screenSequence;
};

export const calculateGridIndex = (
  screenSequence: number | undefined,
  codPosition: CodPositions | undefined,
  screenCount: number,
): number | undefined => {
  if (!screenSequence) {
    return undefined;
  }

  return codPosition === CodPositions.RIGHT
    ? screenCount - screenSequence
    : screenSequence - 1;
};
